module.exports = __webpack_public_path__ + "img/cover-marco-smeets.5fe02370.png";